module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, _vm._l((_vm.reposCat), function(cat, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "sm12": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "py-2 title grey lighten-4"
    }, [_vm._v("\n                " + _vm._s(cat.repos_cat) + "\n              ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0",
      style: (_vm.reposit.filter(function (rec) { return rec.repos_cat_id === cat.repos_cat_id; }).length > 5 ? 'overflow-y: scroll; height: 300px; padding: 1rem 1rem 1rem 0px;' : '')
    }, [_c('v-data-table', {
      attrs: {
        "headers": _vm.reposHeader,
        "items": _vm.reposit.filter(function (rec) { return rec.repos_cat_id === cat.repos_cat_id; }),
        "disable-initial-sort": "",
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', [_vm._v(" " + _vm._s(props.item.doc_name ? props.item.doc_name : '-') + " ")]), _vm._v(" "), _c('td', [_c('a', {
            staticStyle: {
              "text-decoration": "none"
            },
            attrs: {
              "href": _vm.config.FILE_URL(props.item.doc_url),
              "download": ""
            }
          }, [_c('v-btn', {
            staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
            attrs: {
              "small": "",
              "icon": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("file_download")])], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.upload_dt ? _vm.handy.formatDBDateTime(props.item.upload_dt) : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.remarks ? props.item.remarks : '-'))]), _vm._v(" "), _c('td', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdateReposit(props.item)
              }
            }
          }, [_c('v-btn', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "icon": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("create")])], 1)], 1)])]
        }
      }], null, true)
    })], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.lAction === 'view') ? _c('v-btn', _vm._g({
          style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
          attrs: {
            "dark": "",
            "fab": "",
            "fixed": "",
            "color": "accent"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.prepareRepository()
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()]
      }
    }], null, false, 2841529715)
  }, [_vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Add Repository")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-3 title"
  }, [_vm._v("\n            " + _vm._s(_vm.handy.startWithUpper(_vm.lAction)) + " Repository\n          ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-2 pb-2 pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.reposCat,
      "label": "Repository Category",
      "item-text": "repos_cat",
      "item-value": "repos_cat_id",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lReposit.repos_cat_id),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "repos_cat_id", $$v)
      },
      expression: "lReposit.repos_cat_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Remarks (if any)",
      "rows": "2",
      "hide-details": "",
      "maxlength": "250"
    },
    model: {
      value: (_vm.lReposit.remarks),
      callback: function($$v) {
        _vm.$set(_vm.lReposit, "remarks", $$v)
      },
      expression: "lReposit.remarks"
    }
  })], 1), _vm._v(" "), (_vm.lAction === 'create') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .csv, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lReposit)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lReposit.files && _vm.lReposit.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lReposit.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.doc_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (upto 20MB)")])], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .csv, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg"
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lReposit)
      }
    }
  }), _vm._v(" "), (_vm.lReposit.files && _vm.lReposit.files.filter(function (rec) { return rec.is_selected; }).length === 0) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1) : _vm._e(), _vm._v(" "), (_vm.lReposit.files && _vm.lReposit.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lReposit.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.doc_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (upto 20MB)")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deleteReposit(_vm.lReposit)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46b4f06a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Repository.vue
// module id = 831
// module chunks = 24